import { Link } from 'react-router-dom';
import { Product } from '@/mocks/products';
import { useCartContext } from '@/hooks/useCartContext';

interface ProductCardProps {
  product: Product;
}

export function ProductCard({ product }: ProductCardProps) {
  const { addToCart } = useCartContext();

  return (
    <div className="group bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-stone-100 hover:border-stone-200">
      <Link to={`/product/${product.id}`} className="block">
        <div className="relative overflow-hidden bg-stone-50" style={{ paddingBottom: '120%' }}>
          <img
            src={product.images[0]}
            alt={product.name}
            className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          {product.badge && (
            <span className="absolute top-3 left-3 bg-amber-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
              {product.badge}
            </span>
          )}
          {product.originalPrice && (
            <span className="absolute top-3 right-3 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-full">
              -{Math.round((1 - product.price / product.originalPrice) * 100)}%
            </span>
          )}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-end justify-center pb-4 opacity-0 group-hover:opacity-100">
            <button
              onClick={e => { e.preventDefault(); addToCart(product); }}
              className="bg-white text-stone-900 text-sm font-semibold px-5 py-2.5 rounded-xl hover:bg-amber-500 hover:text-white transition-colors whitespace-nowrap"
            >
              Add to Cart
            </button>
          </div>
        </div>
      </Link>

      <div className="p-4">
        <p className="text-xs text-amber-600 font-medium mb-1">{product.category}</p>
        <Link to={`/product/${product.id}`}>
          <h3 className="text-sm font-semibold text-stone-900 leading-snug mb-2 line-clamp-2 hover:text-amber-600 transition-colors">
            {product.name}
          </h3>
        </Link>

        <div className="flex items-center gap-1.5 mb-3">
          <div className="flex items-center gap-0.5">
            {[1, 2, 3, 4, 5].map(star => (
              <i
                key={star}
                className={`text-xs ${star <= Math.floor(product.rating) ? 'ri-star-fill text-amber-400' : star - 0.5 <= product.rating ? 'ri-star-half-fill text-amber-400' : 'ri-star-line text-stone-300'}`}
              />
            ))}
          </div>
          <span className="text-xs text-stone-400">({product.reviewCount})</span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-base font-bold text-stone-900">${product.price}</span>
            {product.originalPrice && (
              <span className="text-xs text-stone-400 line-through">${product.originalPrice}</span>
            )}
          </div>
          <button
            onClick={() => addToCart(product)}
            className="w-8 h-8 flex items-center justify-center bg-amber-50 hover:bg-amber-500 text-amber-600 hover:text-white rounded-lg transition-colors cursor-pointer"
          >
            <i className="ri-shopping-cart-line text-sm" />
          </button>
        </div>
      </div>
    </div>
  );
}
